import React, { useState } from 'react';
import { componentBuilderMap } from '../../../ComponentsMap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand, faCompress, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';

const ComponentEditor = ({ component, onClose  }) => {
    const [isMaximized, setIsMaximized] = useState(false);
    const [isOpen, setIsOpen] = useState(true);
    const toggleMaximize = () => {
        setIsMaximized(!isMaximized);
    };

    const BuilderComponent = componentBuilderMap[component.name];

    return (
        <div className={`component-editor-overlay ${isMaximized ? 'maximized' : '' } ${isOpen ? 'open' : ''}`}>
            <div className="editor-header d-flex justify-content-between align-items-center">
                <div>
                    <h5>Component Quick Editor</h5>
                </div>
                <div>
                    <Button variant="link" onClick={toggleMaximize}>
                        <FontAwesomeIcon icon={isMaximized ? faCompress : faExpand} />
                    </Button>
                    <Button variant="link" onClick={() => {onClose(); setIsOpen(false)}}>
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </div>
            </div>
            <div className="editor-content">
                {BuilderComponent ? <BuilderComponent id={component.id} /> : <p>No editor available for this component.</p>}
            </div>
        </div>
    );
};

export default ComponentEditor; 